import { initializeApp } from 'firebase/app';
import { getFirestore, doc, setDoc, getDoc } from 'firebase/firestore';

const firebaseConfig = {
  // Replace with your Firebase config object
  apiKey: "AIzaSyBgAivs_ppil--JAy2QCsgXJ8Ji9yDFkK0",
  authDomain: "orangedynasty-ffc9d.firebaseapp.com",
  projectId: "orangedynasty-ffc9d",
  storageBucket: "orangedynasty-ffc9d.firebasestorage.app",
  messagingSenderId: "629375150603",
  appId: "1:629375150603:web:5176a1a49c78bd7570750e",
  measurementId: "G-J1RH2LJ4F3"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, doc, setDoc, getDoc };